import httpClient from 'services/httpClient';
import * as api from 'config/routes';

const { REACT_APP_API_BASE_URL } = process.env;

//TODO remove unnecessary requests and separate by functionality
const API = {
  login(payload) {
    return httpClient.post(api.USER_AUTHENTICATE, payload);
  },
  logout(token) {
    return httpClient.get(api.USER_LOGOUT, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  authenticateSSO(provider) {
    return httpClient.get(api.USER_AUTHENTICATE_SSO, {
      requestParams: { provider },
    });
  },
  acceptUserRole(payload, config) {
    return httpClient.post(api.USER_ACCEPT_GRANT, payload, config);
  },
  resetPassword(payload, config) {
    return httpClient.post(api.USER_RESET_PASSWORD, payload, config);
  },
  forgotPassword(params) {
    return httpClient.get(api.USER_FORGOT_PASSWORD, { params });
  },
  getBeverage(id) {
    return httpClient.get(api.BEVERAGE, { requestParams: { id } });
  },
  getLine(line_id) {
    return httpClient.get(api.LINE_STATISTICS, {
      requestParams: { id: line_id },
    });
  },
  getLines() {
    return httpClient.get(api.LINES_STATISTICS);
  },
  getLineTaps(params) {
    return httpClient.get(api.LINE_TAPS, { params });
  },
  getTaps(params) {
    return httpClient.get(api.TAPS, { params });
  },
  patchTap(id, body) {
    return httpClient.patch(api.TAP, body, { requestParams: { id } });
  },
  getItemLine(params) {
    return httpClient.get(api.ITEM_LINES, {
      params,
    });
  },
  getItemLines(params) {
    return httpClient.get(api.ITEM_LINES, { params });
  },
  getContainers(params, config) {
    return httpClient.get(api.CONTAINERS, { params, ...config });
  },
  patchContainer(payload, params, requestParams) {
    return httpClient.patch(api.CONTAINER, payload, {
      params,
      requestParams,
    });
  },
  patchLineTap(payload, requestParams) {
    return httpClient.patch(api.LINE_TAPS, payload, {
      requestParams,
    });
  },
  createTap(body) {
    return httpClient.post(api.TAPS, body);
  },
  changeContainerVolumeUnit(payload) {
    return httpClient.post(api.CHANGE_CONTAINER_UNITS, payload);
  },
  createContainer(payload, params, config) {
    return httpClient.post(api.CONTAINERS, payload, { params, ...config });
  },
  deleteContainer(id) {
    return httpClient.delete(api.CONTAINER, {
      headers: { 'delete-deleted': true },
      requestParams: { id },
    });
  },
  getRoleUsers(params) {
    return httpClient.get(api.ROLE_USERS, { params });
  },
  patchRoleUser(payload, requestParams) {
    return httpClient.patch(api.ROLE_USER, payload, { requestParams });
  },
  getSKUs(params) {
    return httpClient.get(api.SKUS, { params });
  },
  getItemEvents(params) {
    return httpClient.get(api.ITEM_AUDIT_EVENTS, { params });
  },
  getItem(id) {
    return httpClient.get(api.ITEM_STATISTICS, {
      requestParams: { id },
    });
  },
  getItems(params) {
    return httpClient.get(api.ITEMS_STATISTICS, { params });
  },
  addItems(body) {
    return httpClient.post(api.ADD_INVENTORY, body);
  },
  updateItem(id, body) {
    return httpClient.patch(api.ITEM_STATISTICS, body, {
      requestParams: { id },
    });
  },
  patchItem(id, body) {
    return httpClient.patch(api.ITEM, body, {
      requestParams: { id },
    });
  },
  updateItems(body, params) {
    return httpClient.patch(api.ITEMS, body, { params });
  },
  removeItemsFromInventory(body) {
    return httpClient.post(api.REMOVE_INVENTORY, body);
  },
  findProducers(params) {
    return httpClient.get(api.SEARCH_PRODUCERS, { params });
  },
  createProducer(body) {
    return httpClient.post(api.PRODUCERS, body);
  },
  updateBeverage(id, body, params) {
    return httpClient.patch(api.BEVERAGE, body, {
      requestParams: { id },
      params,
    });
  },
  disconnectCurrentItem(body) {
    return httpClient.post(api.DISCONNECT_CURRENT_ITEM, body);
  },
  connectNewLineTap(body) {
    return httpClient.post(api.LINE_CONNECT_NEW_TAP, body);
  },
  connectNewLineSensor(body) {
    return httpClient.post(api.LINE_CONNECT_NEW_SENSOR, body);
  },

  connectNewItem(body) {
    return httpClient.post(api.CONNECT_NEW_ITEM, body);
  },
  connectNextItem(body) {
    return httpClient.post(api.LINE_NEXT_ITEM, body);
  },
  reorder(body) {
    return httpClient.post(api.ITEM_LINE_REORDER, body);
  },
  addNewItemToTheFront(params) {
    return httpClient.get(api.ADD_ITEM_TO_FRONT, { params });
  },
  addNewItemToTheBack(params) {
    return httpClient.get(api.ADD_ITEM_TO_BACK, { params });
  },
  removeItemFromTheQueue(params) {
    return httpClient.get(api.REMOVE_ITEM_LINE, { params });
  },
  switchItemKegLeveling(body) {
    return httpClient.post(api.SWITCH_KEG_LEVELING, body);
  },
  createSKU(body) {
    return httpClient.post(api.SKUS, body);
  },
  patchSKUs(body) {
    return httpClient.patch(api.SKUS, body);
  },
  updateSKU(id, body) {
    return httpClient.patch(api.SKUSES, body, { requestParams: { id } });
  },
  deleteSKU(id) {
    return httpClient.delete(api.SKUSES, {
      headers: { 'delete-deleted': true },
      requestParams: { id },
    });
  },
  getSku(id) {
    return httpClient.get(api.SKUSES, { requestParams: { id } });
  },
  getMyBeverages(params) {
    return httpClient.get(api.BEVERAGES, { params });
  },
  searchBeverages(params) {
    return httpClient.get(api.SEARCH_BEVERAGES, { params });
  },
  createBeverage(payload) {
    return httpClient.post(api.BEVERAGES_CREATE, payload);
  },
  copyBeverage(body) {
    return httpClient.post(api.COPY_BEVERAGE, body);
  },
  updateMyBeverage(id, body) {
    return httpClient.patch(api.BEVERAGE, body, {
      requestParams: { id },
    });
  },
  removeMyBeverage(id) {
    return httpClient.delete(api.BEVERAGE, {
      headers: { 'delete-deleted': true },
      requestParams: { id },
    });
  },
  changeUserRole(params) {
    return httpClient.get(api.USER_ROLE_SWITCH, { params });
  },
  getEstablishment(requestParams) {
    return httpClient.get(api.ESTABLISHMENT, { requestParams });
  },
  getIntegrations(requestParams) {
    return httpClient.get(api.INTEGRATIONS, { requestParams });
  },
  patchEstablishment(patch, requestParams) {
    return httpClient.patch(api.ESTABLISHMENT, patch, { requestParams });
  },
  getUnits(params) {
    return httpClient.get(api.UNITS, { params });
  },
  sendReport(data) {
    return httpClient.post(api.SEND_REPORT, data);
  },
  cleanStart(body) {
    return httpClient.post(api.CLEAN_START, body);
  },
  cleanStop(body) {
    return httpClient.post(api.CLEAN_STOP, body);
  },
  cleanModify(body) {
    return httpClient.post(api.CLEAN_MODIFY, body);
  },
  cleanRemove(body) {
    return httpClient.post(api.CLEAN_REMOVE, body);
  },
  cleanSchedule(body) {
    return httpClient.post(api.CLEAN_SCHEDULE, body);
  },
  cleanAdd(body) {
    return httpClient.post(api.CLEAN_ADD, body);
  },
  updateItemLine(id, body) {
    return httpClient.patch(api.ITEM_LINE, body, { requestParams: { id } });
  },
  getBusinessHours(requestParams) {
    return httpClient.get(api.BUSINESS_HOURS, { requestParams });
  },
  patchBusinessHours(body) {
    return httpClient.patch(api.BUSINESS_HOURS, body);
  },
  patchBusinessHour(payload, requestParams) {
    return httpClient.patch(api.BUSINESS_HOUR, payload, { requestParams });
  },
  fixItemItemLines(body) {
    return httpClient.post(api.FIX_ITEM_ITEM_LINES, body);
  },
  applyItemLineFixes(body) {
    return httpClient.post(api.APPLY_ITEM_LINE_FIXES, body);
  },
  itemLinesCorrect(body) {
    return httpClient.post(api.ITEM_LINES_CORRECT, body);
  },
  getPOSSKUs(params) {
    return httpClient.get(api.POS_SKUS, { params });
  },
  patchPOSSKU(id, body) {
    return httpClient.patch(api.POS_SKU, body, { requestParams: { id } });
  },
  patchPOSSKUs(params, body) {
    return httpClient.patch(api.POS_SKUS, body, { params });
  },
  getUsers() {
    return httpClient.get(api.USERS);
  },
  getUser(user_id, { headers }) {
    return httpClient.get(api.USER, {
      requestParams: { id: user_id },
      headers,
    });
  },
  getRoles() {
    return httpClient.get(api.ROLES);
  },
  addUserRole(body) {
    return httpClient.post(api.USER_GRANT, body);
  },
  lockUserRoles(body) {
    return httpClient.patch(api.USER_GRANT, body);
  },
  resendRoleInvitation(body) {
    return httpClient.post(api.USER_RESEND_INVITATION, body);
  },
  cancelRoleInvitation(body) {
    return httpClient.post(api.USER_CANCEL_INVITATION, body);
  },
  updateUser(id, body) {
    return httpClient.patch(api.USER, body, {
      requestParams: { id },
    });
  },
  swapItemOnTheLine(body) {
    return httpClient.post(api.SWAP, body);
  },
  generateReport(body) {
    return httpClient.post(api.GENERATE_REPORT, body, { timeout: 3 * 60 * 1000 });
  },
  getCleanings() {
    return httpClient.get(api.CLEANINGS);
  },
  getCleaningStatistics() {
    return httpClient.get(api.CLEANING_STATISTICS);
  },
  getCleaningsStatistics(params) {
    return httpClient.get(api.CLEANINGS_STATISTICS, { params });
  },
  getCarriers() {
    return httpClient.get(api.CARRIERS);
  },
  patchRoleUserFlags(body) {
    return httpClient.patch(api.ROLE_USERS_FLAG, body);
  },
  getBundle(params) {
    return httpClient.get(api.BUNDLE, { params });
  },
  activateMenu(body) {
    return httpClient.post(api.ACTIVATE_MENU, body);
  },
  getReport() {
    return httpClient.get(api.REPORT);
  },
  patchReport(data, params) {
    return httpClient.patch(api.REPORT, data, { params });
  },
  createMenu(payload, params, config) {
    return httpClient.post(api.MENUS, payload, { params, ...config });
  },
  deleteMenu(id) {
    return httpClient.delete(api.MENU, {
      headers: { 'delete-deleted': true },
      requestParams: { id },
    });
  },
  updateMenu(id, body) {
    return httpClient.patch(api.MENU, body, {
      requestParams: { id },
    });
  },
  createMenuDesign(payload, params, config) {
    return httpClient.post(api.MENU_DESIGNS, payload, { params, ...config });
  },
  deleteMenuDesign(id) {
    return httpClient.delete(api.MENU_DESIGN, {
      headers: { 'delete-deleted': true },
      requestParams: { id },
    });
  },
  updateMenuDesign(id, body) {
    return httpClient.patch(api.MENU_DESIGN, body, {
      requestParams: { id },
    });
  },
  createMenuList(payload, params, config) {
    return httpClient.post(api.MENU_LISTS, payload, { params, ...config });
  },
  deleteMenuList(id) {
    return httpClient.delete(api.MENU_LIST, {
      headers: { 'delete-deleted': true },
      requestParams: { id },
    });
  },
  updateMenuList(id, body) {
    return httpClient.patch(api.MENU_LIST, body, {
      requestParams: { id },
    });
  },
  reorderContainers(payload) {
    return httpClient.post(api.REORDER_CONTAINERS, payload);
  },
  generateQRCode(uuid, params) {
    return httpClient.get(api.GENERATE_MENU_QR_CODE, {
      baseURL: `${REACT_APP_API_BASE_URL}`,
      requestParams: { uuid },
      params,
    });
  },
  getInventoryAnalyticsReport(body) {
    return httpClient.post(api.REPORT_INVENTORY_ANALYTICS, body);
  },
  getInventoryKegRate(body) {
    return httpClient.post(api.GET_INVENTORY_KEG_RATE, body);
  },
  adjustKegLevel(body) {
    return httpClient.post(api.ADJUST_KEG_LEVEL, body);
  },
  getLinesStatistics() {
    return httpClient.get(api.LINES_STATISTICS);
  },
  patchLines(body, params) {
    return httpClient.patch(api.LINES, body, { params });
  },
  createLine(body) {
    return httpClient.post(api.LINES, body);
  },
  patchLine(body, id) {
    return httpClient.patch(api.LINE, body, { requestParams: { id } });
  },
  postCleanResetStatistic(body) {
    return httpClient.post(api.CLEANING_RESET_STATISTICS, body);
  },
  getCoolers() {
    return httpClient.get(api.COOLERS);
  },
  createCooler(body) {
    return httpClient.post(api.COOLERS, body);
  },
  patchCooler(body, id) {
    return httpClient.patch(api.COOLER, body, { requestParams: { id } });
  },
  getRoleUserBars() {
    return httpClient.get(api.BARS_ROLE_USERS);
  },
  addUserToBar(body) {
    return httpClient.post(api.BARS_ROLE_USERS, body);
  },
  deleteUserFromBar(id) {
    return httpClient.delete(api.BAR_ROLE_USERS, {
      headers: { 'delete-deleted': true },
      requestParams: { id },
    });
  },
  getGetaways() {
    return httpClient.get(api.GATEWAYS);
  },
  getDeviceHistory(body, params) {
    return httpClient.post(api.DEVICE_HISTORY, body, { params });
  },
  getConditions(params) {
    return httpClient.get(api.CONDITIONS, { params });
  },

  getDeviceConnectivityHistory(params) {
    return httpClient.get(api.DEVICE_CONNECTIVITY_HISTORY, { params });
  },
  getSensorDiagnosticInfo(params) {
    return httpClient.get(api.SENSOR_DIAGNOSTIC_INFO, { params });
  },
  getEstablishmentsSensorsData() {
    return httpClient.get(api.ESTABLISHMENTS_SENSORS);
  },
  getCoolerBruSummary(body, params) {
    return httpClient.post(api.COOLER_BRU_SUMMARY, body, { params });
  },
  getAlerts() {
    return httpClient.get(api.ALERTS);
  },
  patchAlerts(data, params) {
    return httpClient.patch(api.ALERTS, data, { params });
  },
  subscribeToAlerts(body, params) {
    return httpClient.post(api.SUBSCRIBE_TO_ALERTS, body, { params });
  },
  unsubscribeFromAlerts(body, params) {
    return httpClient.post(api.UNSUBSCRIBE_FROM_ALERTS, body, { params });
  },
  patchGateways(data, id) {
    return httpClient.patch(api.GATEWAY, data, { requestParams: { id } });
  },
  patchNotification(data, params) {
    return httpClient.patch(api.NOTIFICATIONS, data, { params });
  },
  calibrateSensorAccuracy(body) {
    return httpClient.post(api.CALIBRATE_SENSOR_ACCURACY, body);
  },
  clearSensorsLines(body) {
    return httpClient.post(api.CLEAR_SENSORS_LINES, body);
  },
  replaceBRU(body) {
    return httpClient.post(api.REPLACE_BRU, body);
  },
  getUserDevices() {
    return httpClient.get(api.USER_DEVICES);
  },
  patchUserDevices(id, data) {
    return httpClient.patch(api.USER_DEVICE, data, { requestParams: { id } });
  },
  deleteUserDevice(id) {
    return httpClient.delete(api.USER_DEVICE, {
      headers: { 'delete-deleted': true },
      requestParams: { id },
    });
  },
  registerUserDevice(body) {
    return httpClient.post(api.REGISTER_USER_DEVICE, body);
  },
  getSensor(id) {
    return httpClient.get(api.SENSOR, { requestParams: { id } });
  },
  testUserDeviceNotification(device_id, body) {
    return httpClient.post(api.TEST_DEVICE_NOTIFICATION, body, { requestParams: { device_id } });
  },
  calibrateSensorValues(body) {
    return httpClient.post(api.CALIBRATE_SENSOR_VALUES, body);
  },
  matchSKU(params) {
    return httpClient.post(api.MATCH_SKU, params);
  },
  unmatchSKU(params) {
    return httpClient.post(api.UNMATCH_SKU, params);
  },
  ignoreSKU(params) {
    return httpClient.post(api.IGNORE_SKU, params);
  },
  unignoreSKU(params) {
    return httpClient.post(api.UNIGNORE_SKU, params);
  },

  requestCancellationSubscription(body) {
    return httpClient.post(api.REQUEST_CANCELLATION_SUBSCRIPTION, body);
  },
  requestDemoSubscription(body) {
    return httpClient.post(api.REQUEST_DEMO_SUBSCRIPTION, body);
  },
  getSubscriptions() {
    return httpClient.get(api.SUBSCRIPTION);
  },
  getConditionById(id) {
    return httpClient.get(api.CONDITION, { requestParams: { id } });
  },
  createDistributor(body) {
    return httpClient.post(api.DISTRIBUTORS, body);
  },
  createDeliverySchedules(body) {
    return httpClient.post(api.DELIVERY_SCHEDULES, body);
  },
  patchDeliverySchedules(id, body) {
    return httpClient.patch(api.DELIVERY_SCHEDULE, body, { requestParams: { id } });
  },
  deleteDeliverySchedule(id) {
    return httpClient.delete(api.DELIVERY_SCHEDULE, { requestParams: { id } });
  },
  patchDistributor(id, body) {
    return httpClient.patch(api.DISTRIBUTOR, body, { requestParams: { id } });
  },
  deleteDistributor(id) {
    return httpClient.delete(api.DISTRIBUTOR_DELETE, {
      requestParams: { id },
    });
  },
  createSupportTicket(data) {
    return httpClient.post(api.CREATE_SUPPORT_TICKET, data);
  },
  getHardwareStatus() {
    return httpClient.get(api.HARDWARE_STATUS);
  },
  archiveEstablishment() {
    return httpClient.post(api.ARCHIVE_ESTABLISHMENT);
  },
  unarchiveEstablishment() {
    return httpClient.post(api.UNARCHIVE_ESTABLISHMENT);
  },
  getHelpCenterCategories(lang) {
    return httpClient.get(api.HELP_CENTER, { params: { lang } });
  },

  // Auth-validator methods for POS credential validation.
  // Served by the bartrack API itself (mounted at /api/auth-validator), so
  // these go through the default httpClient — its base URL and JWT auth
  // interceptor apply, no separate instance/baseURL override needed.
  getAuthValidatorIntegrations() {
    return httpClient.get('/auth-validator/integrations');
  },

  getAuthValidatorIntegrationSchema(integrationName) {
    return httpClient.get(`/auth-validator/integrations/${integrationName}`);
  },

  validateAuthCredentials(integrationName, credentials) {
    return httpClient.post(`/auth-validator/validate/${integrationName}`, credentials);
  },

  // POS credentials endpoints. These hit the authenticated /api/pos-credentials router,
  // which runs as the current user and only permits their own establishment (the server
  // derives the establishment from the session, not the URL). httpClient applies the `/api`
  // base URL and the JWT auth interceptor. The establishmentId in the path must match the
  // caller's current establishment or the request is rejected (403).
  getPosCredentials(establishmentId, integrationId) {
    return httpClient.get(`/pos-credentials/${establishmentId}/${integrationId}`);
  },

  // Returns the integration ids that have active saved credentials for the establishment
  // (no credential values). Used to show a "connected" indicator in the UI.
  getPosCredentialsStatus(establishmentId) {
    return httpClient.get(`/pos-credentials/status/${establishmentId}`);
  },

  // Runs realtime validation of the establishment's connected integrations server-side and
  // returns [{ integration_id, name, ok, supported, message }] (no credential values).
  getPosCredentialsHealth(establishmentId) {
    return httpClient.get(`/pos-credentials/health/${establishmentId}`);
  },

  savePosCredentials(establishmentId, integrationId, credentials) {
    // PUT archives any previous active credentials and inserts the new ones for this
    // (establishment, integration) pair.
    return httpClient.put(`/pos-credentials/${establishmentId}/${integrationId}`, {
      credentials,
    });
  },

  updatePosCredentials(establishmentId, integrationId, credentials) {
    // Same archive-then-insert endpoint as savePosCredentials.
    return httpClient.put(`/pos-credentials/${establishmentId}/${integrationId}`, {
      credentials,
    });
  },
  getAuditDetails(params) {
    return httpClient.get(api.AUDIT_DETAILS, { params });
  },
};

export default API;
